import { useMemo } from 'react';
import { useOtherInfoContext } from '../OtherInfoContext';
import { FieldList } from '../FieldList';
import { useMobileOtherInfo } from './MobileOtherInfoContext';

export const MobileTabContent = () => {
  const { params } = useOtherInfoContext();
  const { currentTab, tabs } = useMobileOtherInfo();
  const { fields } = params.metadata;

  const currentTabFields = useMemo(() => {
    if (tabs.length === 0) return fields;
    if (!currentTab) return [];
    return fields.filter((f) => f.tabName === currentTab.tabName);
  }, [fields, currentTab, tabs.length]);

  return <FieldList fields={currentTabFields} parentName="root" />;
};
